import api from '@/services/api'
import store from '@/store'
import type { Widget } from '@/services/widget/types'
import { Widgets } from '@/services/widget/types'
import qs from 'qs'

const getWidgets = async (filters: {
  list_only?: boolean
  page_number?: number
  sort_by?: string
  sort_order?: string
  results_per_page?: number
  search?: string
  status?: string
  type?: string[]
  is_vertical?: boolean[]
}): Promise<{ widgets: Widget[]; total: number }> => {
  const a = await api.get<Widgets>('/widgets', {
    params: filters,
    paramsSerializer: (params) => {
      return qs.stringify(params, { arrayFormat: 'repeat' })
    }
  })
  return a.data
}
const getWidget = async (widget_id: number): Promise<Widget> => {
  try {
    const a = await api.get<Widget>('/widget', { params: { widget_id } })
    return a.data
  } catch (error) {
    return Promise.reject(error)
  }
}
const putWidget = async (widget: Partial<Widget>): Promise<Widget | undefined> => {
  try {
    const a = await api.put<Widget>('/widget', widget)
    return a.data
  } catch (error) {
    await store.dispatch('messages/addMessage', { message: error, type: 'error' })
  }
}
const postWidget = async (widget: Widget): Promise<Widget> => {
  try {
    const a = await api.post('/widget', widget)
    return a.data
  } catch (error) {
    store.dispatch('messages/addMessage', { message: error.response.data.error.description, type: 'error' })
  }
}
const deleteWidget = async (id: number): Promise<void> => {
  await api.delete<Widget>(`/widget/${id}`)
}
const duplicateWidget = async (widget_id: number, widget_name: string): Promise<Widget> => {
  try {
    const a = await api.post<Widget>(`/widget/duplicate`, {
      widget_id,
      widget_name
    })
    return a.data
  } catch (error) {
    if (error?.response?.data?.error?.code !== 'SERVICE_WIDGETS_20') {
      store.dispatch('messages/addMessage', { message: error.response.data.error.description, type: 'error' })
    }
    return Promise.reject(error)
  }
}

export default { getWidgets, getWidget, putWidget, postWidget, deleteWidget, duplicateWidget }
